import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../store/index.js'), 'store/index.js')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/staffs.js'), 'staffs.js')
  resolveStoreModules(require('../store/userGroup.js'), 'userGroup.js')
  resolveStoreModules(require('../store/notifications.js'), 'notifications.js')
  resolveStoreModules(require('../store/ui.js'), 'ui.js')
  resolveStoreModules(require('../store/search.js'), 'search.js')
  resolveStoreModules(require('../store/staff.js'), 'staff.js')
  resolveStoreModules(require('../store/user/emails.js'), 'user/emails.js')
  resolveStoreModules(require('../store/search/parkingAreas.js'), 'search/parkingAreas.js')
  resolveStoreModules(require('../store/search/servingContactUsers.js'), 'search/servingContactUsers.js')
  resolveStoreModules(require('../store/search/userGroup.js'), 'search/userGroup.js')
  resolveStoreModules(require('../store/search/userGroupUsers.js'), 'search/userGroupUsers.js')
  resolveStoreModules(require('../store/search/users.js'), 'search/users.js')
  resolveStoreModules(require('../store/search/parking.js'), 'search/parking.js')
  resolveStoreModules(require('../store/parking/waitingContacts.js'), 'parking/waitingContacts.js')
  resolveStoreModules(require('../store/notifications/notificationPush.js'), 'notifications/notificationPush.js')
  resolveStoreModules(require('../store/user/callHistories.js'), 'user/callHistories.js')
  resolveStoreModules(require('../store/user/contacts.js'), 'user/contacts.js')
  resolveStoreModules(require('../store/search/parkingProvidingUsers.js'), 'search/parkingProvidingUsers.js')
  resolveStoreModules(require('../store/user/faxes.js'), 'user/faxes.js')
  resolveStoreModules(require('../store/user/info.js'), 'user/info.js')
  resolveStoreModules(require('../store/user/parking.js'), 'user/parking.js')
  resolveStoreModules(require('../store/user/parkingAreas.js'), 'user/parkingAreas.js')
  resolveStoreModules(require('../store/user/subleaseContracts.js'), 'user/subleaseContracts.js')
  resolveStoreModules(require('../store/user/tels.js'), 'user/tels.js')
  resolveStoreModules(require('../store/user/userComplianceCheck.js'), 'user/userComplianceCheck.js')
  resolveStoreModules(require('../store/user/userGroup.js'), 'user/userGroup.js')
  resolveStoreModules(require('../store/user/userParkingSourceCheckeds.js'), 'user/userParkingSourceCheckeds.js')
  resolveStoreModules(require('../store/biztel/inProgressCallHistory.js'), 'biztel/inProgressCallHistory.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const storeModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(storeModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
